import { render, staticRenderFns } from "./EditHTMLDialog.vue?vue&type=template&id=6640dd9c&lang=pug&"
import script from "./EditHTMLDialog.ts?vue&type=script&lang=ts&"
export * from "./EditHTMLDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports